import getConfig from 'next/config';

export const isProduction = () => {
    return getConfig().publicRuntimeConfig.env == 'production';
};

export const yaadSarigMerchantId = () => {
    return getConfig().publicRuntimeConfig.yaadSarigMerchantId;
};
